(function($, window) {
    var id = 0;
    
    var AssociatePager = function($wrapper) {
        var instance = 'pager-'+id;
        id++;
        $('<div class="associate-bio-nav"><button type="button" class="icon-arrow-left"></button><span class="associate-bio-paginator"></span><button type="button" class="icon-arrow-right"></button></div>').insertAfter($wrapper);
        $('<div class="associate-bio-pager"></div>').hide().insertAfter($wrapper);
        
        $wrapper.nextAll('.associate-bio-nav').on('click', '.icon-arrow-left, .icon-arrow-right', function() {
            var $pager = $wrapper.next('.associate-bio-pager'), $active = $pager.find('.associate-bio-page-active');
            if ($(this).hasClass('icon-arrow-left')) {
                if ($active.index() === 0) {
                    $pager.find(':last-child').trigger('click');
                } else {
                    $active.prev().trigger('click');
                }
            } else if ($(this).hasClass('icon-arrow-right')) {
                if ($active.index()+1 === $pager.find('.associate-bio-page').length) {
                    $pager.find(':first-child').trigger('click');
                } else {
                    $active.next().trigger('click');
                }
            }

        });
        
        function updatePages() {
            var $content = $wrapper.find('.associate-bio-scroller'), height = $wrapper.height();
            $content.css({'overflow': 'visible', 'height': 'auto'});
            var pages = Math.ceil($content.height()/height), $pager = $wrapper.next('.associate-bio-pager'), 
                $paginator = $wrapper.nextAll('.associate-bio-nav').find('.associate-bio-paginator'), 
                sep = '<span class="associate-bio-sep"> / </span>',
                position = $pager.find('.associate-bio-page-active').index();
            $pager.html('');
            $paginator.html((position+1)+sep+pages);
            for (var i = 0; i < pages; i++) {
                $pager.append('<span class="associate-bio-page"></span>');
            }
            var $pages = $pager.find('.associate-bio-page');
            $pages.on('click', function() {
                var $page = $(this);
                $pages.removeClass('associate-bio-page-active');
                $content.fadeOut(200, function() {
                    $content.css('marginTop', $page.index()*height*-1);
                    $paginator.html(($page.index()+1)+' / '+pages);
                    $content.fadeIn(200, function() {
                        $content.trigger('content-loaded');
                        $page.addClass('associate-bio-page-active');
                        console.log($pages);
                        console.log(($page.index()+1)+sep+pages);
                    });
                });
            });
            if (position >= 0) {
                var index = Math.min(position, pages-1);
                $content.css('marginTop', index*height*-1);
                $pages.find('.associate-bio-page-active').removeClass('associate-bio-page-active');
                $pages.eq(index).addClass('associate-bio-page-active');
            } else {
                $pages.eq(0).addClass('associate-bio-page-active');
            }
        }
            
        $(window).off('.'+instance);
        $(window).on('resize.'+instance, this.updatePager);
        
        this.updatePager = function() {
            var $content = $wrapper.find('.associate-bio-scroller');
            $content.fadeOut(0, function() {
                $content.fadeIn(0, function() {
                    updatePages();
                });
            });
            updatePages();
        };
        
        this.updatePager();
      
        return this;
    };        
    
    $.fn.associatePager = function(options) {
            
        if (typeof options === 'string') {
            if (!$(this).data('associateInstance')) {
                return;
            }
            switch(options) {
                case 'update-pager':
                    $(this).data('associateInstance').updatePager();
                    return;
            }
        }
            
        $(this).each(function() {
            $(this).data('associateInstance', new AssociatePager($(this)));

        });

        return this;
    };
    
})(jQuery, window);
